import React, { useEffect } from "react";
import "./Folder.scss";
import { Link } from "react-router-dom";
import { childFolderType } from "../../../redux/fileManager/fileManagerTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  FolderIcon,
  HideIcon,
  RenameFolderIcon,
  deleteIcon,
  grayViewIcon,
} from "../../../assets/images";

type AppProps = {
  type?: string;
  flag?: boolean;
  setFlag?: (data: boolean) => void;
  showDeleteIcon?: boolean;
  folder: childFolderType;
  folderId?: number;
  isParrentHide?:number|null;
  client_code?: string | number | null;
  history?: any;
  company_name?: string;
  viewMoreFolderId?: number | null | undefined;
  showViewMore: boolean;
  handleToggleViewMore?: () => void;
  handleSetViewMoreFolderId?: (folder_id: number | null | undefined) => void;
  handleSetRenameModalData?: (folderData: childFolderType) => void;
  handleDeleteFileAndFolder?: (folderData: any) => void;
  toggleRenameFolderModal?: () => void;
  isRenameFolderPresent?: boolean;
  setSingleFolderData?: any;
  singleFolderData?: any;
  persistFolderData?: any;
  setPersistFolderData?: any;
  setCheckingBack?: React.Dispatch<React.SetStateAction<boolean>>;
  checkingBack?: boolean;
  setSearchData?: React.Dispatch<React.SetStateAction<string>>;
  setShowSearchData?: React.Dispatch<React.SetStateAction<string>>;
  setShowViewMore?: React.Dispatch<React.SetStateAction<boolean>>;
  setShowViewMoreFiles?: React.Dispatch<React.SetStateAction<boolean>>;
  isFileAndFolderDelete?: boolean;
  handleHideFileFolder?:(data:childFolderType)=>void;
  handleUnHideFileFolder?:(data:childFolderType)=>void;
  isHideAndShowFileFolderPresent?:boolean;

};

type ViewMoreAppProps = {
  folderData: childFolderType;
  handleToggleViewMore?: () => void;
  handleSetRenameModalData?: (folderData: childFolderType) => void;
  handleDeleteFileAndFolder?: (folderData: childFolderType) => void;
  toggleRenameFolderModal?: () => void;
  isFileAndFolderDelete?: boolean;
  handleHideFileFolder?:(data:childFolderType)=>void;
  handleUnHideFileFolder?:(data:childFolderType)=>void;
  isHideAndShowFileFolderPresent?:boolean;
  isParrentHide?:number|null;
};

const ViewMoreBox = ({
  folderData,
  isParrentHide,
  handleToggleViewMore,
  handleSetRenameModalData,
  toggleRenameFolderModal,
  handleDeleteFileAndFolder,
  isFileAndFolderDelete,
  handleHideFileFolder,
  handleUnHideFileFolder,
  isHideAndShowFileFolderPresent
}: ViewMoreAppProps) => {
  const handleRenameFolderData = () => {
    toggleRenameFolderModal && toggleRenameFolderModal();
    handleToggleViewMore && handleToggleViewMore();
    handleSetRenameModalData && handleSetRenameModalData(folderData);
  };
  return (
    <div
      className="folder-view-more-box d-flex align-items-center p-2"
      style={{
        width: "195px",
        height: "129px",
        border: "1px solid #bfcbe1",
      }}
    >
      <div style={{ fontSize: "14px", color: "#262a44" }} className="pl-2">
        <div className="d-flex align-items-center view-card-background pb-3">
          <img src={RenameFolderIcon} alt="rename" className="mr-2" />
          <p className="m-0" onClick={handleRenameFolderData}>
            Rename Folder
          </p>
        </div>
        {isFileAndFolderDelete && (
          <div className="d-flex align-items-center view-card-background mt-1 pb-3">
            <img src={deleteIcon} alt="delete" className="mr-2" />
            <p
              className="m-0"
              onClick={() => handleDeleteFileAndFolder?.(folderData)}
            >
              Delete Folder
            </p>
          </div>
        )}
        {isHideAndShowFileFolderPresent&&isParrentHide&&folderData?.parent_id!==0?null:isHideAndShowFileFolderPresent && (
          <div className="d-flex align-items-center view-card-background mt-1">
            <img src={folderData.is_hidden ? grayViewIcon : HideIcon} alt="delete" className="mr-2" />
            <p
              className="m-0"
              onClick={() => 
                // handleHideFileFolder?.(folderData)
                {
                  if (folderData.is_hidden) {
                    handleUnHideFileFolder?.(folderData);
                  } else {
                    handleHideFileFolder?.(folderData);
                  }
                }
              }
            >
             {folderData.is_hidden ? "Show Folder" : "Hide Folder"}
            </p>
          </div>
          )}
      </div>
    </div>
  );
};

const Folder = ({
  type,
  showDeleteIcon,
  singleFolderData,
  client_code,
  folder,
  folderId,
  flag,
  setFlag,
  history,
  company_name,
  showViewMore,
  handleToggleViewMore,
  handleSetViewMoreFolderId,
  viewMoreFolderId,
  handleSetRenameModalData,
  toggleRenameFolderModal,
  isRenameFolderPresent,
  setSingleFolderData,
  persistFolderData,
  setPersistFolderData,
  setCheckingBack,
  checkingBack,
  setSearchData,
  setShowSearchData,
  setShowViewMore,
  setShowViewMoreFiles,
  handleDeleteFileAndFolder,
  isFileAndFolderDelete,
  handleHideFileFolder,
  handleUnHideFileFolder,
  isHideAndShowFileFolderPresent,
  isParrentHide
}: AppProps) => {



useEffect(() => {
  const handleClickOutside = (event: any) => {
    if ( event?.target?.innerHTML!="Rename Folder" && event?.target?.innerHTML!="Delete Folder" &&event?.target?.innerHTML!="Hide Folder"&&event?.target?.innerHTML!="Show Folder") {
      handleToggleViewMore && handleToggleViewMore();
      handleSetViewMoreFolderId && handleSetViewMoreFolderId(null);
    }
    
  };

  if (showViewMore) {
    document?.addEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document?.removeEventListener("mousedown", handleClickOutside);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [showViewMore]);

  const finalFolderName = folder?.name?.length
    ? folder?.name?.length > 21
      ? `${folder?.name?.slice(0, 21)}...`
      : folder?.name
    : "";
  const finalLink = {
    pathname: `/file-manager/${client_code}/folder/${folder.id}`,
    state: { client_code, company_name, folder },
  };

  const currentFolderDetails = useSelector(
    (state: RootState) => state.fileManager.currentFolderDetails
  );

  useEffect(() => {
    let newData =
      Array.isArray(persistFolderData) &&
      JSON.parse(JSON.stringify(persistFolderData));

    if (currentFolderDetails?.name == "Home") {
      Array.isArray(newData) &&
        newData?.unshift({ parent_id: "0", folder_data: null });
      newData?.length > 0 &&
        setPersistFolderData &&
        setPersistFolderData([...newData]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folder, folderId]);

  useEffect(() => {
    if (currentFolderDetails?.name !== "Home") {
      if (singleFolderData?.folder_data) {
        setPersistFolderData &&
          setPersistFolderData((prev: any) => [
            ...prev,
            singleFolderData?.folder_data,
          ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [singleFolderData]);

  const settingState = () => {
    let newData =
      persistFolderData?.length > 0 &&
      JSON.parse(JSON.stringify(persistFolderData));

    if (flag) {
      Array.isArray(newData) && newData?.push(folder);
    }
    if (newData?.length > 0) {
      setPersistFolderData && setPersistFolderData([...newData]);
    }
    setFlag && setFlag(false);
    setCheckingBack && setCheckingBack(true);
    setSingleFolderData({ folder_id: folder?.id, folder_data: folder });
  };

  const handleViewMoreClick = (folderId: number | null | undefined) => {
    handleToggleViewMore && handleToggleViewMore();
    handleSetViewMoreFolderId && handleSetViewMoreFolderId(folderId);
  
     
  };
 
  const renderDownloadInvoiceToolTip = (props: any) => {
    return (
      <Tooltip id="button-view-open-item" {...props}>
        {folder?.name}
      </Tooltip>
    );
  };

  const renderFolder = () => {
    return (
      <div
        className="folder-detail"
        style={{
          padding: "15px",
          cursor: "pointer",
        }}
      >
        {folder?.name && folder?.name?.length > 21 ? (
          <OverlayTrigger
            placement="top"
            delay={{ show: 250, hide: 250 }}
            overlay={renderDownloadInvoiceToolTip}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <i className="fas fa-folder icon-style"></i> */}
              <img src={FolderIcon} alt="folder" />
              <div
                className="folder-name-style ml-2 mr-3"
                style={{
                  width: "100%",
                  whiteSpace: !!type ? "normal" : "nowrap",
                  fontWeight: "500",
                }}
              >
                {finalFolderName}
              </div>
            </div>
          </OverlayTrigger>
        ) : (
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* <i className="fas fa-folder icon-style"></i> */}
            <img src={FolderIcon} alt="folder" />
            <div
              className="folder-name-style ml-2 mr-3"
              style={{
                width: "100%",
                whiteSpace: !!type ? "normal" : "nowrap",
                fontWeight: "500",
              }}
            >
              {finalFolderName}
            </div>
          </div>
        )}
      </div>
    );
  };
  return (
    <div className="folder-container"  style={{ width: !!type ? "30%" : "23%" }}>
      {viewMoreFolderId === folder?.id && showViewMore && (
        <ViewMoreBox
          handleToggleViewMore={handleToggleViewMore}
          folderData={folder}
          isParrentHide={isParrentHide}
          handleSetRenameModalData={handleSetRenameModalData}
          toggleRenameFolderModal={toggleRenameFolderModal}
          handleDeleteFileAndFolder={handleDeleteFileAndFolder}
          isFileAndFolderDelete={isFileAndFolderDelete}
          handleHideFileFolder={handleHideFileFolder}
          handleUnHideFileFolder={handleUnHideFileFolder}
          isHideAndShowFileFolderPresent={isHideAndShowFileFolderPresent}
        />
      )}
      {isRenameFolderPresent && (
        <div
          className="rename-folder-icon"
          onClick={() => handleViewMoreClick(folder.id)}
        >
          <i
            style={{ fontSize: "25px", color: "#5f697b" }}
            className="las la-ellipsis-v"
          ></i>
        </div>
      )}
      {!!type ? (
        <div
          onClick={() => {
            settingState();
          }}
        >
          {renderFolder()}
        </div>
      ) : (
        <Link
          to={finalLink}
          style={{ textDecoration: "none", width: "100%" }}
          onClick={() => {
            setSearchData && setSearchData("");
            setShowSearchData && setShowSearchData("");
            setShowViewMore && setShowViewMore(false);
            setShowViewMoreFiles && setShowViewMoreFiles(false);
          }}
        >
          {renderFolder()}
        </Link>
      )}
      {/* <div className="date-style">
                {`${folder?.updated_by_name} (${moment.utc(folder?.modified_on).local().format('DD-MM-YY, h:mm a')})`}
            </div> */}
    </div>
  );
};

export default Folder;
